import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.slice(1));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true },
        );
        login(res.data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/practice", { replace: true });
      } catch {
        navigate("/login?error=auth_failed", { replace: true });
      }
    })();
  }, [login, navigate]);

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <p className="font-data text-[#FFE800] text-sm uppercase tracking-widest animate-pulse">
        Verifying Super Earth credentials...
      </p>
    </div>
  );
};

export default AuthCallback;
